export enum ViewQueryParamIncludes {
    RECENTS = 'recents',
    OWNERDETAILS = 'ownerDetails',
    FAVORITES = 'favortes',
    PINNED = 'pinned',
    ORG = 'org',
}
